module.exports = __webpack_public_path__ + "510c5639be2c502aac66639603ceb04a.png";